import { alpha, Theme } from '@mui/material/styles';

export const heroSurfaceBackground = (theme: Theme) => {
  const primaryGlow = alpha(theme.palette.primary.main, 0.16);
  const secondaryGlow = alpha(theme.palette.secondary.main, 0.12);
  const topSoftLight = alpha(theme.palette.background.paper, 0.94);
  const baseColor = theme.palette.background.default;

  return `
    linear-gradient(180deg, ${topSoftLight} 0%, ${baseColor} 35%, ${baseColor} 100%),
    radial-gradient(circle at 10% 10%, ${primaryGlow} 0%, transparent 50%),
    radial-gradient(circle at 90% 15%, ${secondaryGlow} 0%, transparent 45%)
  `;
};

export const surfaceBackgroundSx = (theme: Theme) => ({
  backgroundColor: theme.palette.background.default,
  backgroundImage: heroSurfaceBackground(theme),
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});
